import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { BlastSmartComponent } from './blast-smart/blast-smart.component';
import { BlastEditComponent } from './blast-edit/blast-edit.component';
import { BlastDisplayComponent } from './blast-display/blast-display.component';
import { CollapsibleContainerModule } from 'ng2-app/borrower-fd/borrower-fd-sidebar/collapsible-container/collapsible-container.module';



@NgModule({
  declarations: [BlastSmartComponent, BlastEditComponent, BlastDisplayComponent],
  imports: [
    CollapsibleContainerModule,
    CommonModule,
    MatInputModule,
    MatExpansionModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatGridListModule,
    MatIconModule,
    ReactiveFormsModule
  ],
  exports: [BlastSmartComponent]
})
export class BlastModule { }
